import { useState } from 'react';

export default function Thanks2026lmssoudanPage() {
  const [copied, setCopied] = useState(false);

  const handleCopyId = () => {
    navigator.clipboard.writeText('832 7048 7045');
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: 'linear-gradient(160deg, #faf7ff 0%, #f3eeff 40%, #eef8f6 100%)' }}>

      {/* 星空背景 */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(50)].map((_, i) => {
          const sizes = [0.8, 1, 1.2, 1.5, 1.8, 2];
          const size = sizes[i % sizes.length];
          const lefts = [3,8,14,19,25,31,37,42,48,53,59,64,70,75,81,86,92,97,5,11,17,23,29,35,41,47,55,61,67,73,79,85,91,96,2,9,16,22,28,34,40,46,52,58,65,71,77,83,89,95];
          const tops = [5,12,18,24,30,36,42,48,54,60,66,72,78,84,90,7,13,19,25,31,37,43,49,55,61,67,73,79,85,91,3,10,16,22,28,34,40,46,52,58,64,70,76,82,88,94,8,15,21,27];
          const delays = [0,0.5,1,1.5,2,2.5,3,3.5,0.2,0.7,1.2,1.7,2.2,2.7,3.2,0.4,0.9,1.4,1.9,2.4,2.9,3.4,0.1,0.6,1.1,1.6,2.1,2.6,3.1,3.6,0.3,0.8,1.3,1.8,2.3,2.8,3.3,3.8,0.05,0.55,1.05,1.55,2.05,2.55,3.05,3.55,0.15,0.65,1.15,1.65];
          const durations = [2,2.5,3,3.5,4,2.2,2.7,3.2,3.7,2.4,2.9,3.4,2.1,2.6,3.1,3.6,2.3,2.8,3.3,3.8,2.0,2.5,3.0,3.5,4.0,2.2,2.7,3.2,3.7,4.2,2.4,2.9,3.4,3.9,2.1,2.6,3.1,3.6,2.3,2.8,3.3,3.8,2.0,2.5,3.0,3.5,4.0,2.2,2.7,3.2];
          return (
            <div
              key={i}
              className="absolute rounded-full"
              style={{
                width: `${size}px`,
                height: `${size}px`,
                left: `${lefts[i]}%`,
                top: `${tops[i]}%`,
                background: `rgba(160, 120, 220, 0.35)`,
                animation: `twinkle ${durations[i]}s ease-in-out infinite`,
                animationDelay: `${delays[i]}s`,
              }}
            />
          );
        })}
      </div>

      {/* 光のオーブ */}
      <div className="absolute top-20 left-1/4 w-96 h-96 rounded-full pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(160,120,240,0.1) 0%, transparent 70%)' }}></div>
      <div className="absolute bottom-40 right-1/4 w-80 h-80 rounded-full pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(60,180,160,0.08) 0%, transparent 70%)' }}></div>

      <div className="relative z-10 w-full max-w-lg mx-auto px-4 py-10">

        {/* ヘッダー */}
        <div className="text-center mb-8">
          <p className="text-xs tracking-widest mb-3" style={{ color: '#a78bca', fontFamily: 'Cormorant Garamond, serif', letterSpacing: '0.25em' }}>
            ✦ LEMURIA MAGIC SCHOOL ✦
          </p>
          <h1 className="text-xl font-bold leading-relaxed mb-2" style={{ color: '#5b3d8a', fontFamily: 'Noto Serif JP, serif' }}>
            お申し込みありがとうございます
          </h1>
          <div className="w-16 h-px mx-auto" style={{ background: 'linear-gradient(90deg, transparent, #a78bca, transparent)' }}></div>
        </div>

        {/* メインカード */}
        <div className="rounded-2xl p-6 mb-6" style={{ background: 'rgba(255,255,255,0.75)', backdropFilter: 'blur(12px)', boxShadow: '0 4px 30px rgba(160,120,220,0.12)', border: '1px solid rgba(167,139,202,0.2)' }}>
          <p className="text-sm leading-relaxed mb-4" style={{ color: '#4a3060', fontFamily: 'Noto Serif JP, serif' }}>
            このたびは、<br />
            <strong>レムリアの魔法学校・体験説明会</strong>へ<br />
            お申し込みいただき、誠にありがとうございます。
          </p>
          <p className="text-sm leading-relaxed" style={{ color: '#4a3060', fontFamily: 'Noto Serif JP, serif' }}>
            みなさまの貴重なお時間をいただいての入学説明会となります。<br />
            必ず以下の案内をご確認いただき、ご参加のほど、よろしくお願いいたします。
          </p>
        </div>

        {/* 大切なご案内 */}
        <div className="rounded-2xl p-6 mb-6" style={{ background: 'rgba(255,255,255,0.75)', backdropFilter: 'blur(12px)', boxShadow: '0 4px 30px rgba(160,120,220,0.12)', border: '1px solid rgba(167,139,202,0.2)' }}>
          <h2 className="text-base font-bold mb-4 flex items-center gap-2" style={{ color: '#7c4daa', fontFamily: 'Noto Serif JP, serif' }}>
            <span style={{ color: '#a78bca' }}>✦</span>
            大切なご案内
          </h2>
          <p className="text-sm leading-relaxed mb-3" style={{ color: '#4a3060', fontFamily: 'Noto Serif JP, serif' }}>
            本説明会は一方向で学びを受け取るセミナーではなく、<br />
            レムリアの魔法学校への<strong>「入学をご検討いただくための説明会」</strong>です。
          </p>
          <p className="text-sm leading-relaxed mb-3" style={{ color: '#4a3060', fontFamily: 'Noto Serif JP, serif' }}>
            そのため、フェイストゥフェイスでの対話を大切にしております。
          </p>
          <div className="rounded-xl p-4 mb-3" style={{ background: 'linear-gradient(135deg, rgba(167,139,202,0.15), rgba(100,180,160,0.1))', border: '1px solid rgba(167,139,202,0.3)' }}>
            <p className="text-sm font-bold text-center" style={{ color: '#7c4daa', fontFamily: 'Noto Serif JP, serif' }}>
              当日は顔出し参加を必須とさせていただきます。
            </p>
          </div>
          <p className="text-sm leading-relaxed mb-3" style={{ color: '#4a3060', fontFamily: 'Noto Serif JP, serif' }}>
            カメラオンの状態でお一人おひとりのお顔を拝見しながら想いを共有し、質疑応答も行ってまいります。
          </p>
          <p className="text-sm leading-relaxed" style={{ color: '#4a3060', fontFamily: 'Noto Serif JP, serif' }}>
            安心安全な場づくりのためにも、ご理解とご協力をお願いいたします。
          </p>
        </div>

        {/* 当日の準備 */}
        <div className="rounded-2xl p-6 mb-6" style={{ background: 'rgba(255,255,255,0.75)', backdropFilter: 'blur(12px)', boxShadow: '0 4px 30px rgba(160,120,220,0.12)', border: '1px solid rgba(167,139,202,0.2)' }}>
          <h2 className="text-base font-bold mb-4 flex items-center gap-2" style={{ color: '#7c4daa', fontFamily: 'Noto Serif JP, serif' }}>
            <span style={{ color: '#a78bca' }}>✦</span>
            当日のご準備
          </h2>
          <p className="text-sm leading-relaxed mb-4" style={{ color: '#4a3060', fontFamily: 'Noto Serif JP, serif' }}>
            説明会当日は、安定したインターネット環境のもと、<strong>カメラと音声のご準備</strong>をお願いいたします。
          </p>
          <h3 className="text-sm font-bold mb-3" style={{ color: '#7c4daa', fontFamily: 'Noto Serif JP, serif' }}>
            本説明会でお伝えする内容
          </h3>
          <ul className="space-y-2">
            {[
              'レムリアの魔法学校の理念',
              'どのような学びのプロセスがあるのか',
              '入学後の流れ',
              'ご質問への直接回答',
            ].map((item, idx) => (
              <li key={idx} className="flex items-start gap-2 text-sm" style={{ color: '#4a3060', fontFamily: 'Noto Serif JP, serif' }}>
                <span className="mt-0.5 flex-shrink-0" style={{ color: '#a78bca' }}>✧</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Zoomリンク */}
        <div className="rounded-2xl p-6 mb-6" style={{ background: 'linear-gradient(135deg, rgba(124,77,170,0.08), rgba(60,180,160,0.06))', backdropFilter: 'blur(12px)', boxShadow: '0 4px 30px rgba(160,120,220,0.15)', border: '1px solid rgba(167,139,202,0.35)' }}>

          {/* Zoomボタン */}
          <a
            href="https://us02web.zoom.us/j/83270487045?pwd=N1ZKUitDMitzSjQ2cjJVV1dOU01ldz09"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full py-4 rounded-xl font-bold text-base flex items-center justify-center gap-3 cursor-pointer whitespace-nowrap transition-all hover:opacity-90"
            style={{
              background: 'linear-gradient(135deg, #7c4daa, #5b3d8a)',
              color: '#ffffff',
              letterSpacing: '0.08em',
              boxShadow: '0 4px 20px rgba(124,77,170,0.4)',
              textDecoration: 'none',
            }}
          >
            <i className="ri-video-chat-line text-xl"></i>
            ZOOMリンクをLINEで受取る
          </a>
        </div>

        {/* フッターメッセージ */}
        <div className="text-center py-4">
          <p className="text-xs" style={{ color: '#a78bca', fontFamily: 'Cormorant Garamond, serif', letterSpacing: '0.2em' }}>
            ✦ &nbsp; それでは説明会当日にお会いしましょう &nbsp; ✦
          </p>
        </div>

      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400;1,600&family=Noto+Serif+JP:wght@400;500;600;700&display=swap');
        @keyframes twinkle {
          0%, 100% { opacity: 0.15; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.4); }
        }
      `}</style>
    </div>
  );
}
